import React, {useEffect, useState} from "react";
import {Alert, Card, IconButton, Snackbar} from "@mui/material";
import {NewsApi} from "../../../../utils/NewsApi";
import styles from "../../../../assets/css/page.module.scss";
import CustomTable from "../../../../components/subComponents/Table";
import Pagination from "../../../../components/subComponents/Pagination";
import {Link} from "react-router-dom";
import configs from '../../../../utils/config.json';
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import {CategoryApi} from "../../../../utils/CategoryApi";

const CategoryList = (props) => {

    const [page, setPage] = useState(1);
    const [rows, setRows] = useState([]);
    const [dataLoading, setDataLoading] = useState(false);
    const [openSnackBar1, setOpenSnackBar1] = useState(false);
    const [message, setMessage] = useState('');

    const handleClickSnackBar1 = (text) => {
        setOpenSnackBar1(true);
        setMessage(text);
    };
    const handleCloseSnackBar1 = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenSnackBar1(false);
    };

    const deleteNews = async (id) => {
        setDataLoading(true);
        await NewsApi.deleteNews(id, () => {
            fetchData(page);
            handleClickSnackBar1('دسته بندی حذف شد!');

        }, () => {
        });
    }
    const fetchData = async (page) => {
        setDataLoading(true);
        await CategoryApi.getAll(
            ({data}) => {
                setRows(data);
                setDataLoading(false);

            },
            (error) => {
                setDataLoading(false);
                setRows([]);

            });
        setPage(page);

    }
    const headers = [
        {
            field: 'title', title: 'عنوان', width: 250, renderCell: (row) => (
                <div>
                    <Link to={`/admin/category/${row.id}`}>{row.name}</Link>
                </div>
            ),
        },


        {
            field: 'userStatus', title: '---', width: 120,
            align: 'right',
            renderCell: (row) => (
                <>
                    <IconButton color="error" component="button" onClick={() => {
                        (async () => {
                            await deleteNews(row.id);
                        })();
                    }}>
                        <DeleteOutlineRoundedIcon/>
                    </IconButton>

                </>)
        },


    ];


    useEffect(() => {
        (async () => {
            await fetchData(1);
        })();
    }, []);

    return <div style={{ padding: 15}}>
        <Card elevation={3} style={{height: 'calc(100vh - 30px)', direction: "rtl", overflow: "hidden"}}>
            <div className={styles.container}>
                <CustomTable headers={headers} rows={rows} loading={dataLoading}  bottom={160}/>


            </div>
        </Card>
        <Snackbar open={openSnackBar1} autoHideDuration={2000}
                  onClose={handleCloseSnackBar1}
                  className={styles.snackBar}
                  anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
        >
            <Alert
                severity="success"
                className={styles.txt}
            >
                {message}
            </Alert>
        </Snackbar>
    </div>;
}

export default CategoryList;